<template>
    <div class="select-option" :class="{border:border,active:active}">
        <div class="checkbox"></div>
        <div class="option-name" v-html="desc"></div>
    </div>
</template>
<script>
    export default {
        name: 'SelectOption',
        props: {
            active:Boolean,
            desc:String,
            border:{
                type:Boolean,
                default:true
            }
        },
    }
</script>
<style lang="scss" scoped>
    .select-option{
        width: 100%;
        padding:13px 16px;
        display: flex;
        align-items: center;
        overflow: hidden;
        &.border{
            border: 1px solid #D6D3D3;
        }
        &.border.active{
            border-color: #FFA307;
            outline: 0;
            box-shadow: inset 0 0 1px rgba(0,0,0,.075), 0 0 8px rgba(255, 163, 7,.1);
        }
        &.active{
            .checkbox{
                border-color: #FFA307;
                background-image: url("../img/yes.png");
                background-size: 100% 100%;
            }
        }
        .checkbox{
            width: 12px;
            height: 12px;
            border: 1px solid #D6D3D3;
        }

        .option-name{
            margin-left: 10px;
            flex: 1;
            font-size:15px;
            color: #999999;
        }
    }
    /*.select-option:active {*/
    /*    */
    /*}*/
</style>
